import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {CountShapesModel} from '../../../../../models/questions/subModels/countShapes.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-shape-count',
  templateUrl: './evo-shape-count.component.html',
  styleUrls: ['./evo-shape-count.component.css']
})
export class EvoShapeCountComponent implements OnInit {

  Enums = Enums;
  QuestionModel: QuestionModel;
  @Input() question: QuestionModel = new CountShapesModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): CountShapesModel {

    return <CountShapesModel>this.question;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.countShapes) {
        return true;
      }
    }

    return false;
  }

}
